export const TransactionDataType = {
  Payment: 'Payment',
  Transaction: 'Transaction',
} as const;
export type TransactionDataType = (typeof TransactionDataType)[keyof typeof TransactionDataType];
